import { createAction } from 'redux-actions'

const prefix = 'PERSONA_LIBRARY/'

export const setPersonas = createAction(`${prefix}SET_PERSONAS`)

export const openPersonaDialog = createAction(`${prefix}OPEN_PERSONA_DIALOG`)
export const closePersonaDialog = createAction(`${prefix}CLOSE_PERSONA_DIALOG`)

export const setSelectedPersona = createAction(`${prefix}SET_SELECTED_PERSONA`)
export const setSelectedPersonaField = createAction(`${prefix}SET_SELECTED_PERSONA_FIELD`)

export const createPersonaStart = createAction(`${prefix}CREATE_PERSONA_START`)
export const createPersonaSuccess = createAction(`${prefix}CREATE_PERSONA_SUCCESS`)
export const createPersonaError = createAction(`${prefix}CREATE_PERSONA_ERROR`)

export const updatePersonaStart = createAction(`${prefix}UPDATE_PERSONA_START`)
export const updatePersonaSuccess = createAction(`${prefix}UPDATE_PERSONA_SUCCESS`)
export const updatePersonaError = createAction(`${prefix}UPDATE_PERSONA_ERROR`)

export const generatePersonasStart = createAction(`${prefix}GENERATE_PERSONAS_START`)
export const generatePersonasSuccess = createAction(`${prefix}GENERATE_PERSONAS_SUCCESS`)
export const generatePersonasError = createAction(`${prefix}GENERATE_PERSONAS_ERROR`)
